module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('pageTitle', {
    attrs: {
      "title": "我的订单",
      "showBack": false
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "当前订单"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "历史订单"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'tab1') ? _c('div', {
    on: {
      "touchmove": function($event) {
        return _vm.loadPage(1)
      },
      "touchend": function($event) {
        return _vm.loadEnd(1)
      }
    }
  }, [(this.loadMsg[0] != '') ? _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[0],
      "trigger": _vm.trigger[0]
    },
    on: {
      "refresh": function($event) {
        return _vm.refresh(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('orderList', {
    attrs: {
      "CardKindDiplay": _vm.g_UserInfo.Card_Kind_Diplay,
      "orderList": _vm.List[0]
    },
    on: {
      "cancelOrder": _vm.CancelOrder,
      "payMoney": _vm.goPayMoney,
      "goDetail": _vm.goDetail
    }
  }), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "showExtend": true,
      "mainTitle": "您还没有订单哦，快去逛逛吧！",
      "extendBtn": true,
      "mainIcon": "noOrder",
      "subTitle": "优惠活动",
      "subIcon": "activity",
      "noMore": _vm.loadMsg[0] == "没有更多记录",
      "isLoading": _vm.loadState[0],
      "overZero": _vm.List[0].length > 0,
      "showBtn": true
    },
    on: {
      "btnHandler": _vm.goHome
    }
  }), _vm._v(" "), (_vm.loadState[0]) ? _c('div', {
    staticClass: "loading"
  }, [(this.loadMsg[0] != '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin-top": "2.1rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    }
  }) : _vm._e(), _vm._v(" "), (this.loadMsg[0] == '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "66px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('div', {
    on: {
      "touchmove": function($event) {
        return _vm.loadPage(2)
      },
      "touchend": function($event) {
        return _vm.loadEnd(2)
      }
    }
  }, [(this.loadMsg[1] != '') ? _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[1],
      "trigger": _vm.trigger[1]
    },
    on: {
      "refresh": function($event) {
        return _vm.refresh(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('orderList', {
    attrs: {
      "orderList": _vm.List[1],
      "showCurrent": false
    },
    on: {
      "deleteOrder": _vm.DeleteOrder,
      "goDetail": _vm.goDetail
    }
  }), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您暂无历史订单",
      "mainIcon": "noOrder",
      "noMore": _vm.loadMsg[1] == "没有更多记录",
      "isLoading": _vm.loadState[1],
      "overZero": _vm.List[1].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[1]) ? _c('div', {
    staticClass: "loading"
  }, [(this.loadMsg[1] != '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin-top": "2.1rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    }
  }) : _vm._e(), _vm._v(" "), (this.loadMsg[1] == '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    }
  }) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab3') ? _c('div', {
    on: {
      "touchmove": function($event) {
        return _vm.loadPage(2)
      },
      "touchend": function($event) {
        return _vm.loadEnd(2)
      }
    }
  }, [(this.loadMsg[2] != '') ? _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing[2],
      "trigger": _vm.trigger[2]
    },
    on: {
      "refresh": function($event) {
        return _vm.refresh(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('orderList', {
    attrs: {
      "orderList": _vm.List[2]
    },
    on: {
      "cancelOrder": _vm.CancelOrder,
      "deleteOrder": _vm.DeleteOrder,
      "goDetail": _vm.goDetail
    }
  }), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您暂无K币订单",
      "mainIcon": "noOrder",
      "noMore": _vm.loadMsg[2] == "没有更多记录",
      "isLoading": _vm.loadState[2],
      "overZero": _vm.List[2].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[2]) ? _c('div', {
    staticClass: "loading"
  }, [(this.loadMsg[2] != '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin-top": "2.1rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    }
  }) : _vm._e(), _vm._v(" "), (this.loadMsg[2] == '加载中...') ? _c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingWhite.gif")
    }
  }) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('pop', {
    attrs: {
      "display": _vm.popDisplay,
      "title": "温馨提示",
      "msg": _vm.popMsg,
      "onlyOk": _vm.popOnlyOk
    },
    on: {
      "closeHandler": _vm.closePop,
      "okHandler": _vm.closeYES
    }
  }), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67e45dbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/index.vue
// module id = 1529
// module chunks = 18